import ReactiveState from '@/ui-kit/hooks/ReactiveState';

class GridPagination {
  #reactiveState;

  constructor({
    pageNumber = 0,
    pageSize = 0,
    totalItems = 0,
  }) {
    this.#reactiveState = new ReactiveState({
      pageNumber,
      pageSize,
      totalItems,
    });
  }

  get pageNumber() {
    return this.#reactiveState.value.pageNumber;
  }

  get pageSize() {
    return this.#reactiveState.value.pageSize;
  }

  get totalItems() {
    return this.#reactiveState.value.totalItems;
  }

  get firstIndexOnPage() {
    return (this.pageSize * this.pageNumber) - this.pageSize;
  }

  get lastIndexOnPage() {
    return this.pageSize * this.pageNumber > this.totalItems
      ? this.totalItems
      : this.pageSize * this.pageNumber;
  }

  get pagesAmount() {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  get options() {
    return this.#reactiveState.value;
  }

  setPageNumber(pageNumber) {
    this.setOptions({ pageNumber });
  }

  setPageSize(pageSize) {
    this.setOptions({ pageSize });
  }

  setOptions(options) {
    this.#reactiveState.patch(options);
  }
}

export default GridPagination;
